import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { Router } from '@angular/router';

import { GATEWAY_COMMISSIONING_STEP, GatewayCommissioningStore, InstallationsStore } from '@store';

@Component({
  selector: 'app-transfer-success',
  templateUrl: './transfer-success.component.html',
  styleUrls: ['./transfer-success.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TransferSuccessComponent {
  readonly step = GATEWAY_COMMISSIONING_STEP;

  @Input() activeStep: GATEWAY_COMMISSIONING_STEP;
  @Output() reset = new EventEmitter();

  constructor(
    public gatewayCommissioningStore: GatewayCommissioningStore,
    private installationsStore: InstallationsStore,
    private router: Router
  ) {}

  goToInstallationList(): void {
    this.installationsStore.listInstallations();
    this.gatewayCommissioningStore.clearState();

    this.router.navigate(['/installations']);
  }

  newSetup(): void {
    this.gatewayCommissioningStore.clearState();
    this.reset.emit();
  }
}
